var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import UsedGauge from './UsedGauge';
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
var UsedGaugeStore = /** @class */ (function () {
    function UsedGaugeStore() {
        var _this = this;
        this.datas = [];
        this.loaded = false;
        this.create = function (usedGauge) {
            _this.loaded = false;
            return api.post("usedgauges/".concat(usedGauge.stretch_id), usedGauge).then(_this.set)
                .catch(function (error) {
                console.log('create - catch - error: ', error);
                // this.loaded = true
                throw new Error(error);
            });
        };
        this.set = function (value) {
            console.log('UsedGaugesStore - set - value: ', JSON.stringify(value));
            _this.loaded = true;
            if (value) {
                _this.data = new UsedGauge(value) || null;
                return _this.data;
            }
            else {
                return null;
            }
        };
        this.setDatas = function (values) {
            _this.loaded = true;
            if (values) {
                _this.datas = values.filter(function (usedGauge) { return !usedGauge.stretch.disabled_at; }).map(function (value) { return new UsedGauge(value) || null; });
                return _this.datas;
            }
            else {
                return [];
            }
        };
        this.setLoaded = function (value) {
            _this.loaded = value;
        };
    }
    UsedGaugeStore.prototype.read = function (stretch_id) {
        var _this = this;
        this.loaded = false;
        if (!stretch_id) {
            return api.get("usedgauges?eager=[stretch]").then(this.setDatas);
        }
        return api.get("usedgauges/".concat(stretch_id))
            .then(this.set)
            .catch(function (error) {
            console.log('read - catch - error: ', error);
            _this.setLoaded(true);
            throw error;
        });
    };
    UsedGaugeStore.prototype.update = function (usedGauge) {
        var _this = this;
        console.log('update - usedGauge: ', usedGauge);
        this.loaded = false;
        return api.put("usedgauges/".concat(usedGauge.stretch_id), usedGauge).then(this.set)
            .catch(function (error) {
            console.log('update - catch - error: ', error);
            _this.loaded = true;
            throw new Error(error);
        });
    };
    UsedGaugeStore.prototype.reset = function (stretch_id) {
        var _this = this;
        this.loaded = false;
        return api.patch("usedgauges/".concat(stretch_id)).then(this.set)
            .catch(function (error) {
            console.log('reset - catch - error: ', error);
            _this.loaded = true;
            throw new Error(error);
        });
    };
    __decorate([
        observable
    ], UsedGaugeStore.prototype, "data", void 0);
    __decorate([
        observable
    ], UsedGaugeStore.prototype, "datas", void 0);
    __decorate([
        observable
    ], UsedGaugeStore.prototype, "loaded", void 0);
    __decorate([
        action
    ], UsedGaugeStore.prototype, "read", null);
    __decorate([
        action
    ], UsedGaugeStore.prototype, "create", void 0);
    __decorate([
        action
    ], UsedGaugeStore.prototype, "update", null);
    __decorate([
        action
    ], UsedGaugeStore.prototype, "reset", null);
    __decorate([
        action
    ], UsedGaugeStore.prototype, "set", void 0);
    __decorate([
        action
    ], UsedGaugeStore.prototype, "setDatas", void 0);
    __decorate([
        action
    ], UsedGaugeStore.prototype, "setLoaded", void 0);
    return UsedGaugeStore;
}());
export default UsedGaugeStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/UsedGauges/UsedGaugeStore.ts
// module id = 733
// module chunks = 0